import { render, staticRenderFns } from "./FourInAList.vue?vue&type=template&id=a9620ad2&scoped=true&"
import script from "./FourInAList.vue?vue&type=script&lang=js&"
export * from "./FourInAList.vue?vue&type=script&lang=js&"
import style0 from "./FourInAList.vue?vue&type=style&index=0&id=a9620ad2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9620ad2",
  null
  
)

export default component.exports